import React from 'react';
import { Typography, Grid, Card, Box } from '@mui/material';

const TechnologySection = () => {
  return (
    <section id="technology" className="whitepaper-section">
      <Typography variant="h2" className="section-title">
        Technology Foundation
      </Typography>

      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Card className="capability-card">
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, color: '#60a5fa' }}>
              Core Platform
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, color: '#e0e7ef' }}>
              <strong>Apache Kafka:</strong> Distributed streaming platform providing fault-tolerant, high-throughput data pipelines.
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, color: '#e0e7ef' }}>
              <strong>Confluent Platform:</strong> Enterprise Kafka with 200+ connectors, Schema Registry, ksqlDB, and enterprise-grade security.
            </Typography>
            <Box className="code-block">
              • Multi-region replication<br/>
              • Tiered storage (S3/Azure/GCS)<br/>
              • Role-based access control<br/>
              • End-to-end encryption<br/>
              • Audit logging
            </Box>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card className="capability-card">
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, color: '#10b981' }}>
              Stream Processing
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, color: '#e0e7ef' }}>
              <strong>ksqlDB:</strong> SQL-based stream processing for filtering, transformation, and aggregation.
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, color: '#e0e7ef' }}>
              <strong>Flink:</strong> Advanced stateful processing for complex event correlation and ML inference.
            </Typography>
            <Box className="code-block">
              • Real-time filtering rules<br/>
              • Schema normalization<br/>
              • Threat intelligence enrichment<br/>
              • Anomaly detection<br/>
              • Multi-stage pipelines
            </Box>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card className="capability-card">
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, color: '#f59e0b' }}>
              Integration Ecosystem
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, color: '#e0e7ef' }}>
              <strong>200+ Pre-built Connectors:</strong> Native integration with security tools, cloud platforms, and databases.
            </Typography>
            <Box className="code-block">
              <strong>Sources:</strong> Syslog, S3, Azure Blob, HTTP, Databases<br/>
              <strong>Destinations:</strong> Splunk, Elastic, Chronicle, S3, Snowflake<br/>
              <strong>Processing:</strong> Lambda, Functions, Custom Apps
            </Box>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card className="capability-card">
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, color: '#8b5cf6' }}>
              Operations & Monitoring
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, color: '#e0e7ef' }}>
              <strong>Confluent Control Center:</strong> Real-time monitoring, alerting, and management UI.
            </Typography>
            <Box className="code-block">
              • Cluster health dashboards<br/>
              • Topic/partition monitoring<br/>
              • Consumer lag tracking<br/>
              • Performance metrics<br/>
              • Alert configuration<br/>
              • Data lineage tracking
            </Box>
          </Card>
        </Grid>
      </Grid>
    </section>
  );
};

export default TechnologySection;
